module.exports = __webpack_public_path__ + "static/media/apartment2.0e947289.png";